module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'viewership-block': !_vm.isGraphOnly
    }
  }, [_c('div', {
    staticClass: "viewership-block__header"
  }, [_c('div', [_c('h4', [_vm._v("Viewership -\n         "), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('toggle-button', {
    staticClass: "viewership-block__toggle-button",
    attrs: {
      "left-label": "Graph",
      "right-label": "Table",
      "toggle-value": !_vm.changeToTable
    },
    on: {
      "toggle": _vm.toggleDisplayOfData
    }
  })] : _vm._e()], 2), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('small', {
    staticClass: "viewership-block__tip"
  }, [_vm._v("*Select networks below to see Daypart breakdowns.")])] : _vm._e()], 2), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('date-range', {
    staticClass: "viewership-block__date-range"
  }), _vm._v(" "), (!_vm.isTargetActivated && _vm.showFilter) ? _c('action-button', {
    attrs: {
      "color": "secondary",
      "id": "networksBtn",
      "label": "Networks"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNetworksModal.apply(null, arguments)
      }
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (!_vm.changeToTable) ? [_c('div', {
    staticClass: "viewership-block__graph-container"
  }, [_c('div', {
    staticClass: "viewership-block__y-title"
  }, [_vm._v("Index")]), _vm._v(" "), _c('div', {
    staticClass: "viewership-block__x-title"
  }, [_vm._v("Rating")]), _vm._v(" "), (_vm.allowViewershipToRender) ? _c('viewership-graph', {
    ref: "viewershipGraph",
    staticClass: "viewership-block__graph",
    attrs: {
      "chartData": _vm.dataForGraph,
      "axises": _vm.axises,
      "onClick": _vm.viwershipOnClick
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewershipData) ? _c('api-error-message', {
    attrs: {
      "api-name": "viewership graph data"
    }
  }) : _vm._e()], 1)] : [_c('div', {
    staticClass: "viewership-block__table-container"
  }, [_c('styled-table', {
    attrs: {
      "theme": "light",
      "data": _vm.dataForTable,
      "headers": _vm.tableHeaders,
      "sort": {
        prop: "size",
        order: "descending"
      }
    },
    on: {
      "sort-change": _vm.handleSortChange
    },
    scopedSlots: _vm._u([{
      key: "item.size",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n           " + _vm._s(_vm.formatAudienceSize(item.size)) + "\n         ")]
      }
    }])
  })], 1)], _vm._v(" "), (!_vm.isGraphOnly) ? [(!_vm.isTargetActivated && _vm.showFilter) ? _c('viewership-filter', {
    ref: "filter",
    attrs: {
      "networks": _vm.networks,
      "selected-networks": _vm.selectedViewershipNetworks
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e23e7556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/graphs/viewership/components/Viewership.vue
// module id = 1995
// module chunks = 0